"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WALLET_PORTFOLIO_FAIL = exports.USER_PORTFOLIO_FAIL = void 0;
exports.USER_PORTFOLIO_FAIL = "Couldn't fetch user portfolio";
exports.WALLET_PORTFOLIO_FAIL = "Couldn't fetch wallet portfolio";
